import type { Color } from '#/theme/theme';
import type { FlashStyle } from '#/zustand-stores/flashesStore';

export const flashBarStyleColor: Record<
  FlashStyle,
  { bg: Color; color: Color }
> = {
  success: {
    bg: 'brandGreen',
    color: 'white',
  },
  info: {
    bg: 'lightContentGrey',
    color: 'white',
  },
  warn: {
    bg: 'brandYellow',
    color: 'mediumContentGrey',
  },
  error: {
    bg: 'alertRed',
    color: 'white',
  },
};
